<template>

	<div id="app">
		<div  class="confirmOrderStyle">
			<div   class="titlesStyle mb30">
				<div  class="title-info-box w1300 mauto">
					<div  class="title-box">
						<div  class="logo-box flex-between align-center"><img	src="@/assets/img/default1/logob.png" alt="">
							<!---->
							<div  class="content col666 flex-start align-center ml20 pl20">
								<div  class="f20" style="color: rgb(102, 102, 102);">
									{{ merchant.sitename }}
								</div>
							</div>
						</div>
						<div  class="right-menu-btn">
							<div  class="nav-box line-right">
								<a href="https://jijuxjs.com/"><span >官网首页</span></a>
							</div>
							<div  class="nav-box">
								<a  href="https://jijuxjs.com/orderSearch"><span >订单查询</span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
      <div class="main-box">
          <div class="good-box">
            <div class="good-box-title">
              <div>选择商品</div>
            </div>
            <div class="good-box-content">
              <el-form label-width="80px" label-position="left" >
                <el-form-item size="medium " v-if="cateList && cateList.length > 0" label="商品分类">
                  <el-select v-model="cateName" @change="handleChangeCate" placeholder="请选择">
                    <el-option
                      v-for="item in cateList"
                      :key="item.id"
                      :value="item">
                      <div class="option-box">
                        <span >{{ item.name }}</span>
                        <span style="color: #8492a6; font-size: 13px">包含{{ item.count }}种商品</span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item   label="商品名称">
                  <el-select v-model="goodName" @change="handleChangeGoods" :filterable="true" placeholder="商品名称">
                    <el-option
                      v-for="item in cateGoodsList"
                      :key="item.id"
                      :label="item.name "
                      :value="item.id">
                      <div class="option-box">
                        <span >{{ item.name }}</span>
                      </div>

                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="商品单价" v-if="goods">
                    <div class="form-item-my">
                      <div>
                        <span>{{ order.price }}元</span>
                      </div>
                      <div>库存数量</div>
                      <div>
                        {{ kucunDesc ? kucunDesc : "库存" + goods.kucun + "件" }}
                      </div>
                    </div>
                </el-form-item>
                <el-form-item label="购买数量">
                  <div class="form-item-my">
                    <div>
                      <el-input-number v-model="order.quantity" :min="minLimit !==0 ? minLimit :1" :precision="0" :max="goods ? maxLimit : 1" label="描述文字"></el-input-number>
                    </div>
                  </div>

                </el-form-item>
                <el-form-item >
                  <div class="">
                    <div style="display: flex;flex-wrap: wrap;">
                      <div v-for="(item,index) in goodlistManzengVos" :key="index" class="text item" style="display: inline-block;color: #ff0000;font-size: 17px;font-family: PingFang SC;">
                        <el-badge :value="`赠${item.zengsong}`" class="item" style="margin-right: 30px;margin-top: 10px;">
                          <el-button size="small">{{ "买" + item.manzu }}</el-button>
                        </el-badge>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="联系方式">
                  <div class="contact">
                    <div>
                      <input v-model="order.contact"  placeholder="必填"
                             class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
                    </div>
                    <div class="notice-btn-box">
                      <div class="notice-btn" :class="order.isTel === 1 ? 'active' :''" @click="switchNotice('isTel')">短信提醒</div>
                      <div class="notice-btn" :class="order.isEmail === 1 ? 'active' :''" @click="switchNotice('isEmail')">邮件提醒</div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="手机号码" v-if="order.isTel === 1">
                  <div>
                    <input  v-model="order.tel"  placeholder="请输入手机号码接收短信提醒"
                           class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
                  </div>
                </el-form-item>
                <el-form-item label="邮箱地址" v-if="order.isEmail === 1">
                  <div>
                    <input  v-model="order.email"  type="text" placeholder="请输入邮箱号码接收短信提醒"
                           class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
                  </div>
                </el-form-item>
                <el-form-item label="取卡密码" v-if="goods && goods.isPwd === 1">
                  <div>
                    <input v-model="order.pwd"  placeholder="[必填]请输入取卡密码(6-20位)"
                           class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
                  </div>
                </el-form-item>
                <el-form-item label="优惠券" v-if="isCoupon===1">
                  <div>
                    <input  v-model="order.couponCode" @input="validCoupon" placeholder="请输入优惠券码"
                            class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
                  </div>
                  <div v-show="isCoupon===1">
                    <p class="f12 col666 mt10" style="color: green !important;" v-if="order.couponCode && coupon">当前优惠券优惠：{{ coupon.type === 1 ? (coupon.couponAmount + "元") : coupon.couponAmount + "%" }}</p>
                    <p class="f12 col666 mt10" style="color: red !important;" v-else-if="order.couponCode && !coupon">{{ couponError }}</p>
                  </div>
                </el-form-item>
                <el-form-item label="支付方式" >
                  <div class="pay-box">
                     <div class="pay-box-item" :class="order.gateway === 'alipay' ? 'active' : ''" v-if="alipay" @click="changeGateway('alipay')">
                       <img src="@/assets/img/default1/zfb.png">
                       <div>支付宝支付</div>
                     </div>
                    <div class="pay-box-item" :class="order.gateway === 'weixingzh' ? 'active' : ''" v-if="weixingzh" @click="changeGateway('weixingzh')">
                      <img src="@/assets/img/default1/wx.png">
                      <div>微信支付</div>
                    </div>
                    <div class="pay-box-item" :class="order.gateway === 'yunshanfuwap' ? 'active' : ''" v-if="yunshanfuwap"  @click="changeGateway('yunshanfuwap')">
                      <img src="@/assets/img/default1/quickpass.png">
                      <div>云闪付</div>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="info-box">
            <div class="info-item">
              <div class="info-box-title">
                <div>卖家信息</div>
              </div>
              <div class="info-box-content">
                <div class="info-item">
                  <div>QQ：{{ merchant.qq }}</div>
                  <div class="copy-btn" @click="_copy(merchant.qq)">复制</div>
                </div>
                <div class="info-item">
                  <div>微信：{{ merchant.mchWechat }}</div>
                  <div class="copy-btn" @click="_copy(merchant.mchWechat)">复制</div>
                </div>
                <div class="info-item">
                  <div>扫码手机购买</div>
                  <div class="copy-btn" @mouseenter="showQr('showSjQr')" @mouseleave="showQr('showSjQr')"><img src="@/assets/img/default1/ewm-icon.png" style="width: 21px; height: 21px"/></div>
                  <div class="qr-box"  v-show="showSjQr">
                    <vue-qr v-if="buyqrCodeUrl" class="qr-code1" :text="buyqrCodeUrl" :logoScale="0.2" :logoMargin="3" :margin="20" colorDark="#000" colorLight="#fff"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-item mt10">
              <div class="info-box-title">
                <div>官方客服</div>
              </div>
              <div class="info-box-content">
                <div class="info-item">
                  <div>QQ：{{ config.qq }}</div>
                  <div class="copy-btn" @click="_copy(config.qq)">复制</div>
                </div>
                <div class="info-item">
                  <div>电话：{{ config.tel }}</div>
                  <div class="copy-btn" @click="_copy(config.tel)">复制</div>
                </div>
                <div class="info-item">
                  <div>微信：{{ config.wechartName }}</div>
                  <div class="copy-btn"  @mouseenter="showQr('showPtQr')" @mouseleave="showQr('showPtQr')"><img src="@/assets/img/default1/ewm-icon.png" style="width: 21px; height: 21px"/></div>
                  <div class="qr-box" v-show="showPtQr">
                    <img src="@/assets/img/default1/ptewm.jpg" style="width: 190px; height: 190px"/>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </div>

      <div class="remark-box mt10" v-if="goods">
        <div class="remark-box-title">
            <div >商品描述</div>
        </div>
        <div class="remark-box-content">
          <div v-html="goods.remark"></div>
        </div>
      </div>

      <div class="remark-box mt10">
        <div class="remark-box-title">
          <div >支付详情</div>
        </div>
        <div class="remark-box-content">
          <div  class="pay-price flex-between align-center">
            <div >
              <div  class="flex-start align-center f18"
                    style="color: rgb(29, 29, 31);">
                <p  class="mr30"><span >商品价格：</span> <span
                  class="col333">￥{{ goods ? Math.round(order.price * this.order.quantity * 100) / 100 : 0 }}</span>
                </p>
                <p  class="mr30"><span >手续费：</span> <span
                  class="col333">￥{{ fee }}</span>
                </p>
                <p ><span >优惠金额：</span> <span
                  class="col333" style="color:red;">-{{ couponAmount }}</span>
                </p>
              </div>
            </div>
            <div  class="flex-start align-center">
              <div ><span  class="f20"
                           style="color: rgb(29, 29, 31);">合计：<span
                style="color: rgb(229, 81, 81);">￥</span></span>
                <span
                  class="colF71148 f30 b">{{ payAmt }}</span></div>
              <!-- <div @click="submit" style="cursor:pointer"  class="confirm-order-btn f16 flex-center align-center">确认订单
              </div> -->
              <el-button :loading="loading" @click="submit" class="confirm-order-btn f16 flex-center align-center">
                确认订单
              </el-button>

            </div>
          </div>
        </div>
      </div>
		</div>

		<el-dialog title="商家公告" :visible.sync="dialogVisible" width="30%" >
			<div style="padding: 20px">
				{{ merchant ? merchant.gonggao : "" }}
			</div>
			<span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">已了解</el-button>
        </span>
		</el-dialog>

    <el-dialog title="付款提示" :visible.sync="paydialogVisible"  width="30%">
      <div  style="padding: 20px">
        {{ merchant ? merchant.payTips : "" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payNow">已了解</el-button>
      </span>
    </el-dialog>

    <el-dialog  :visible.sync="payVisible" width="30%" :beforeClose="stopSync">
      <div class="pay-ewm-box">
        <div class="pay-ewm-box-header">
          扫码付款
        </div>
        <div class="ewm-box">
          <div v-loading="loading" class="pay-qr-code-box">
            <vue-qr v-if="qrCodeUrl" class="pay-qr-code" :logoSrc="channelsImg" :text="qrCodeUrl" :size="200" :correctLevel="0" :logoScale="0.2" :logoMargin="3" :margin="10"
                    backgroundDimming="rgb(255,0,0)"/>
            <span v-else class="loading">二维码加载中...</span>
          </div>
          <p style="color: #515151;">订单号：{{ orderid }}</p>
          <p style="color: #515151;">付款金额：<font style="color: red;">{{ orderMoney }}</font>元</p>
          <p v-show="error" style="color: red;">{{ error }}</p>
        </div>
        <div class="tips-box">
          <div class="tips-box-left">
            <img src="@/assets/img/default1/tips.png">
          </div>
          <div  class="tips-box-right">
            <p>请使用手机{{channelsText}}扫描二维码支付</p>
            <p>30分钟内未付款的订单将会超时关闭</p>
            <p>支付成功后，请等待页面自动跳转</p>
          </div>
        </div>
      </div>
    </el-dialog>

	</div>
</template>

<script>
import { listGoodsByShop, getConfig, getCoupon, listGoodsByCategory, listGoodsByGoods, getGoods, createOrder, prePay, pay,listOrder, getMerchant } from "@/api/goods";
import { validatenull, validPhone, validatEmail, validatZnum, validatWx, validatQQ }                                                     from "@/utils/validate";
import vueQr                                                                                                                             from "vue-qr";

export default {
	name       : "IndexDefault",
	components : { vueQr },
	data () {
		return {
      payVisible:false,
      paydialogVisible:false,
      cateName:"",
      goodName:"",
      cateIndex:0,
      goodsIndex:0,
      isList              : false,
      showPtQr:false,
      showSjQr:false,
      searchTitle         :"",
      searchList          : [],
			cateList           : [],
			cateGoodsList      : [],
			goodsList          : [],
			selectedCateid     : null,
			telClass           : "",
			remark           : "",
			goods              : null,
      minLimit:0,
      maxLimit:0,
			merchant           : {},
			openid             : null,
			order              : {
				contact  : null,
				gateway  : null,
				quantity : 1,
				price    : 0,
				goodid   : null,
				isEmail  : 0,
				email    : null,
				isTel    : 0,
				tel      : null,
				pwd      : null,
			},
			orderRes           : {},
			smsFee             : 0.1,
			loading            : false,
			buyqrCodeUrl          : null,
			dialogVisible      : false,
			config             : {},
			coupon             : null,
			couponError        : "优惠券不存在",
			goodlistManzengVos : [],
			isCoupon           : 0,
      orderInterval  : null,
      orderid        : null,
      orderMoney     : null,
      qrCodeUrl      : "", // 二维码的内容
      channel        : null,
      error          : null,
      channelsText :'',
      channelsImg :'',
      channels:[
        {
          name:"alipay",
          val:"支付宝",
          image: require("../../../assets/img/default1/zfb.png")
        },
        {
          name:"weixin",
          val:"微信",
          image: require("../../../assets/img/default1/wx.png")
        },
        {
          name:"yunshanfuwap",
          val:"云闪付",
          image: require("../../../assets/img/default1/quickpass.png")
        }
      ]
		};
	},
	created () {
		const type   = this.$route.params && this.$route.params.type;
		const linkId = this.$route.params && this.$route.params.linkId;
		if ( !type || !linkId ) {
			this.$message.error("链接无效");
		}
		// 获取配置信息
		this.loadConfig();
		// 获取商户信息
		this.loadMerchant(type, linkId);
		// 获取商品信息
		this.loadGoods(type, linkId);
	},
	mounted () {
		this.buyqrCodeUrl = window.location.href;
		this.qrCodeUrl = window.location.href;
	},
	watch    : {
		"order.quantity" (newVal, oldVal) {
			if ( this.goods.isWholesale !== 1 ) {
				return false;
			}
			this.order.price = this.goods.price;
			this.goods.goodlistWholesaleVos.sort((a, b) => b.pfQuantity - a.pfQuantity);
			for (let index = 0 ; index < this.goods.goodlistWholesaleVos.length ; index++) {
				if ( newVal >= this.goods.goodlistWholesaleVos[index].pfQuantity ) {
					this.order.price = this.goods.goodlistWholesaleVos[index].pfPrice;
					break;
				}
			}
		},
	},
	computed : {
		kucunDesc  : function () {
			if ( !this.goods || this.goods.kucunShow === 0 ) {
				return "";
			}
			if ( this.goods.kucun === 0 ) {
				return "库存不足";
			}
			else if ( this.goods.kucun < 100 ) {
				return "少量库存";
			}
			else {
				return "库存充足";
			}
		},
		kucunColor : function () {
			if ( !this.kucunDesc ) {
				return "#999";
			}
			else if ( this.kucunDesc === "库存不足" ) {
				return "red";
			}
			else if ( this.kucunDesc === "少量库存" ) {
				return "orange";
			}
			else {
				return "green";
			}
		},
		// 订单金额
		orderTotal : function () {
			if ( !this.goods || !this.goods.price || !this.order.quantity ) {
				return 0;
			}
			return Math.round(this.order.price * this.order.quantity * 100) / 100;
		},
		fee        : function () {
			let amount = 0;
			if ( this.order.gateway && this.goods && this.goods.buyerFee === 2 ) {
				const vo = this.merchant.merchantRateVos.find(item => item.gateway === this.order.gateway);
				amount   = Math.round(((1 - vo.rate) * (this.orderTotal - this.couponAmount)) * 100) / 100;
			}
			if ( this.order.isTel ) {
				amount = Math.round((amount + this.smsFee) * 100) / 100;
			}
			return amount;
		},
		payAmt     : function () {
			let sum = this.orderTotal;
			sum     = sum + this.fee;
			sum     = sum - this.couponAmount;
			return Math.round(sum * 100) / 100;
		},
		// 优惠金额
		couponAmount : function () {
			if ( !this.goods || !this.coupon ) {
				return 0;
			}
			if ( this.coupon.type === 2 ) {
				return Math.round(this.orderTotal * (this.coupon.couponAmount / 100) * 100) / 100;
			}
			else {
				return this.coupon.couponAmount;
			}
		},
    yunshanfuwap       : function () {
      if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
        return false;
      }
      let isVisible=  this.merchant.merchantRateVos.findIndex(item => item.gateway === "yunshanfuwap") >= 0;
      // console.log("alipay isVisible",isVisible);
      if ( isVisible === false ) {
        this.changeGateway(null)
      }
      return isVisible;
    },
		alipay       : function () {
			if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
				return false;
			}
			let isVisible=  this.merchant.merchantRateVos.findIndex(item => item.gateway === "alipay") >= 0;
			// console.log("alipay isVisible",isVisible);
			if ( isVisible === false ) {
				this.changeGateway(null)
			}
			return isVisible;
		},
		weixin    : function () {
			if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
				return false;
			}
			let isVisible= this.merchant.merchantRateVos.findIndex(item => item.gateway === "weixin") >= 0;
			// console.log("weixin isVisible",isVisible);
			if ( isVisible === false ) {
				this.changeGateway(null)
			}
			return isVisible;
		},
		weixingzh    : function () {
			if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
				return false;
			}
			let isVisible= this.merchant.merchantRateVos.findIndex(item => item.gateway === "weixingzh") >= 0;
			// console.log("weixingzh isVisible",isVisible);
			if ( isVisible === false ) {
				this.changeGateway(null)
			}
			return isVisible;
		},
	},
	methods  : {
    showQr (key) {
      if (key === 'showSjQr') {
        this.showSjQr=!this.showSjQr
      } else {
        this.showPtQr=!this.showPtQr
      }
    },
    switchNotice (key) {
      this.order[key] = this.order[key]===0 ? 1 : 0
    },
		// 复制操作
		_copy (context) {
			// 创建输入框元素
			let oInput   = document.createElement("input");
			// 将想要复制的值
			oInput.value = context;
			// 页面底部追加输入框
			document.body.appendChild(oInput);
			// 选中输入框
			oInput.select();
			// 执行浏览器复制命令
			document.execCommand("Copy");
			// 弹出复制成功信息
			this.$message.success("复制成功");
			// 复制后移除输入框
			oInput.remove();
		},
		// 加载商户
		loadMerchant (type, linkId) {
			getMerchant(type, linkId).then(res => {
				if ( res.code !== 200 ) {
					this.$router.push("/404");
				}
				document.title = res.data.sitename;
				this.merchant  = res.data;
				localStorage.setItem("merchant", JSON.stringify(res.data));

				// 公告是否弹出
				if ( res.data.isAlertGonggao ) {
					this.dialogVisible = true;
				}
			});
		},
		loadConfig () {
			getConfig().then(res => {
				this.config = res.data;
			});
		},
		// 加载分类商品
		loadGoods (type, linkId) {
			this.cateList  = [];
			this.goodsList = [];
			if ( type === "shop" ) {
				listGoodsByShop(linkId).then(res => {
					// 分类
					res.data.forEach(item => {
						if ( this.cateList.findIndex(d => d.id === item.cateid) === -1 ) {
							this.cateList.push({ id : item.cateid, name : item.catename });
						}
					});
					// 分类数量
					this.cateList.forEach(cate => {
						cate.count = res.data.filter(g => g.cateid === cate.id).length;
					});
					// 商品
					this.goodsList = res.data;
					// 默认选中第一个分类
					this.handleChangeCate({ id : res.data[0].cateid });
				});
			}
			else if ( type === "category" ) {
				listGoodsByCategory(linkId).then(res => {
					if ( res.code !== 200 ) {
						return this.$message.error(res.msg);
					}
					// 商品
					this.goodsList      = res.data;
					this.selectedCateid = res.data[0].cateid;
					this.goodsList.forEach(item => {
						this.cateGoodsList.push({ id : item.id, name : item.goodname });
					});
					this.handleChangeGoods(this.goodsList[0].id);
				});
			}
			else if ( type === "goods" ) {
				listGoodsByGoods(linkId).then(res => {
					if ( res.code !== 200 ) {
						return this.$message.error(res.msg);
					}
					this.goodsList.push(res.data);
					this.cateGoodsList.push({ id : res.data.id, name : res.data.goodname });
					this.order.goodid = res.data.id;
					this.handleChangeGoods(res.data.id);
          console.log(this.cateGoodsList)
				});
			}
		},
		// 选择分类
		handleChangeCate (cate) {
      console.log(cate)
      console.log(this.cateList)
      this.cateIndex = this.cateList.findIndex(item => item.id === cate.id)
      this.cateName = this.cateList[this.cateIndex].name
			this.selectedCateid = cate.id;
			this.cateGoodsList  = [];
      this.searchList  = [];
			this.goods          = null;
			const list          = this.goodsList.filter(item => item.cateid === this.selectedCateid);
			list.forEach(item => {
        this.isList = true;
        this.cateGoodsList.push({ id : item.goodid, name : item.goodname });
        this.searchList.push({ id : item.goodid, name : item.goodname });
			});
			this.handleChangeGoods(this.cateGoodsList[0].id);
		},
		// 选择商品
		handleChangeGoods (goodsid) {
			this.order.goodid = goodsid;
      this.goodsIndex=this.cateGoodsList.findIndex(item => item.id === goodsid)

			getGoods(this.order.goodid).then(res => {
				if ( res.code !== 200 ) {
					this.$message.warning(res.msg);
					return false;
				}
				this.goods              = res.data;
        this.goodName = res.data.goodname
				// let zzreg               = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
				// this.goods.remark       = this.goods.remark.replace(zzreg, "<a href='$1$2' target='_blank'>$1$2</a>");
				// this.remark = this.HTMLDecode(this.goods.remark);
				this.goods.remark = this.addATagButNotImage(this.goods.remark);
        this.order.quantity = res.data.lowLimit!==0 ? res.data.lowLimit : 1
        if (res.data.kucun !== 0) {
          this.maxLimit=res.data.kucun
        }
        if (res.data.maxLimit !== 0) {
          this.maxLimit = res.data.maxLimit>res.data.kucun ? res.data.kucun : res.data.maxLimit
        } else {
          this.maxLimit = res.data.kucun
        }

        this.minLimit = res.data.lowLimit
				this.isCoupon           = res.data.isCoupon;
				this.order.price        = res.data.price;
				this.goodlistManzengVos = res.data.goodlistManzengVos;
				this.merchant.merchantRateVos=res.data.merchantRateVos
			});
		},
		addATagButNotImage (str) {
			var arr = [];
			str = str.replace(/<\/?\w+[^>]*>/g,function (s) {
				arr.push(s);
				return "\x01";
			});
			str = str.replace(/(http(s)?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-\.\/?%&=]*)?/g,function (s,a) {
				return "<a href='"+(a?"":"http://")+s+"'>"+s+"</a>";
			});
			str = str.replace(/(\b\d{11}\b)/g,"<a href=tel:$1>$1</a>");
			str = str.replace(/\x01/g,function (s) {
				return arr.shift();
			});
			return str;
		},
		// HTML反转义
	 HTMLDecode(text) {
			var temp = document.createElement("div");
			temp.innerHTML = text;
			var output = temp.innerText;
			temp = null;
			return output;
		},
		// 选择短信邮件
		changeNotify () {
			this.order.isEmail = this.order.isTel;
		},
		concatWx () {
			window.open("https://work.weixin.qq.com/kfid/kfcce6bc38ab931ba87", "_blank");
		},
		// 选择支付方式
		changeGateway (val) {
			this.order.gateway = val;
		},
		// 校验表单
		valid () {
			if ( validatenull(this.order.goodid) ) {
				this.$message.warning("请选择商品");
				return false;
			}
			if ( validatenull(this.order.quantity) ) {
				this.$message.warning("请输入购买数量");
				return false;
			}
			if ( !validatZnum(this.order.quantity) ) {
				this.$message.warning("购买数量有误");
				return false;
			}
			if ( !this.goods.kucun || this.order.quantity > this.goods.kucun ) {
				this.$message.warning("库存不足");
				return false;
			}
			if ( validatenull(this.order.contact) ) {
				this.$message.warning("请填写联系方式");
				return false;
			}
			if ( this.goods.contactLimit === 2 && !validatQQ(this.order.contact) ) {
				this.$message.warning("联系方式请填写qq号");
				return false;
			}
			if ( this.goods.contactLimit === 3 && !validPhone(this.order.contact) ) {
				this.$message.warning("联系方式请填写手机号");
				return false;
			}
			if ( this.goods.contactLimit === 4 && !validatWx(this.order.contact) ) {
				this.$message.warning("联系方式请填写微信号");
				return false;
			}
			if ( this.order.isTel && (!this.order.tel || !validPhone(this.order.tel)) ) {
				this.$message.warning("请填写正确的手机号");
				return false;
			}
			if ( this.order.isEmail && (!this.order.email || !validatEmail(this.order.email)) ) {
				this.$message.warning("请填写正确的邮箱地址");
				return false;
			}
			if ( this.goods.isPwd === 1 && validatenull(this.order.pwd) ) {
				this.$message.warning("请填写取卡密码");
				return false;
			}
			if ( this.goods.isPwd === 1 && !validatenull(this.order.pwd) && (this.order.pwd.length < 6 || this.order.pwd.length > 20) ) {
				this.$message.warning("取卡密码长度为6-20位");
				return false;
			}
			if ( validatenull(this.order.gateway) ) {
				this.$message.warning("请选择支付方式");
				return false;
			}
			return true;
		},
    searchGoods () {
      this.cateGoodsList = this.searchList
      let searchContent = this.searchTitle
      let goodList = []
      if (searchContent !== "") {
        goodList= this.cateGoodsList.filter(function (n) {
          return n.name.includes( searchContent )
        })
        let arr = Object.keys(goodList);
        if (arr.length === 0) {
          this.handleChangeGoods(this.cateGoodsList[0].id);
          return this.$message.error("未找到'"+searchContent+"'相关商品！");
        } else {
          this.cateGoodsList = goodList
        }
        this.handleChangeGoods(this.cateGoodsList[0].id);
      }
    },
		// 校验优惠券
		validCoupon () {
			if ( !this.goods || !this.order.couponCode || this.order.couponCode.length < 6 ) {
				return false;
			}
			this.coupon = null;
			getCoupon(this.goods.id, this.order.couponCode).then(res => {
				if ( res.code === 200 ) {
					this.coupon = res.data;
				}
				else {
					this.couponError = res.msg;
				}
			});
		},
		// 提交
		submit () {
			if ( !this.valid() ) {
				return false;
			}
			this.order.isTel   = this.order.isTel ? 1 : 0;
			this.order.isEmail = this.order.isEmail ? 1 : 0;

			this.loading = true;
			createOrder(this.order).then(res => {
				this.loading = false;
				if ( res.code !== 200 ) {
					return this.$message.error(res.msg);
				}
				this.orderRes           = res.data;
				this.orderRes.avatarUrl = this.goods.avatarUrl;
        this.orderid= res.data.orderid
        if ( this.merchant && this.merchant.isAlertAgree === 1 ) {
          this.paydialogVisible = true;
        } else {
          this.doPrePay()
        }
			});
		},

    Channel(channelName,type) {
      let channelIndex=this.channels.findIndex(item => item.name === channelName)
      return type==="img" ? this.channels[channelIndex].image : this.channels[channelIndex].val
    },
    payNow () {
      this.paydialogVisible = false;
      this.doPrePay()
    },
    stopSync (done) {
      done()
      console.log(123)
      clearInterval(this.orderInterval);
      this.orderInterval = null;
    },

    doPrePay () {
      this.payVisible=true
      this.loading = true;
      this.error   = null;
      // console.log("this.orderid",this.orderid);
      prePay(this.orderid).then(res => {
        let that = this;
        if ( res.code !== 200 ) {
          this.error = res.msg;
          return this.$message.error(res.msg);
        }
        // 监听支付结果
        this.orderInterval = setInterval(() => {
          listOrder(that.orderid).then(res => {
            if ( res.data[0].isPaid === 1 ) {
              clearInterval(this.orderInterval);
              this.orderInterval = null;
              that.$message.success("付款成功，即将跳转订单查询页面");
              setTimeout(() => {
                window.location.href = "https://jijuxjs.com/orderSearch?keywords=" + that.orderid;
              }, 1000);
            }
          });
        }, 3 * 1000);

        this.loading    = false;
        this.orderMoney = res.data.orderMoney;
        // 生成二维码 支付宝dopay后生成 微信直接生成
        if ( res.data.providerDirectory.indexOf("weixin") >= 0 ) {
          this.channel   = "weixin";
          this.qrCodeUrl = "https://jijuxjs.com/mpay/wxDesk?orderid=" + this.orderid + "&pid=" + res.data.providerId + "&ap=" + res.data.providerDirectory + "&amt=" + res.data.orderMoney;
        }
        else {
          this.channel = "alipay";
          // if (res.data.providerDirectory === 'alipaywap' || res.data.providerDirectory === 'alipay') {
          // if (res.data.providerDirectory === 'alipaywap' || res.data.providerDirectory === 'adapay_alipay') {
          if ( res.data.providerDirectory === "alipaywap" ) {
            // 支付宝官方 二维码为H5页面自动跳转
            this.qrCodeUrl = "https://jijuxjs.com/mpay/zfbDesk?orderid=" + this.orderid + "&pid=" + res.data.providerId + "&ap=" + res.data.providerDirectory;
          }
            // else if ( res.data.providerDirectory === "alipay" ) {
            // 	// 支付宝官方 二维码为页面自动跳转
            // 	this.qrCodeUrl = "https://jijuxjs.com/mpay/zfbDesk?orderid=" + this.orderid + "&pid=" + res.data.providerId + "&ap=" + res.data.providerDirectory;
          // }

          else {
            if (res.data.providerDirectory.indexOf("yunshanfuwap") >= 0 ) {
              this.channel = "yunshanfuwap";
              pay({
                ap :  res.data.providerDirectory, pid :  res.data.providerId, orderid :  res.data.orderid, openid : this.openid,
              }).then(resp => {
                if ( resp.code !== 200 ) {
                  return this.$message.error("下单失败！");
                }
                if ( resp.data.infoType === "url" ) {
                  // console.log("res.data.payUrl",res.data.payUrl);
                  // this.qrCodeUrl = res.data.payUrl;
                  // console.log(this.qrCodeUrl);
                  this.qrCodeUrl = resp.data.payUrl
                }
              })
            } else {
              if ( this.$route.query.go === undefined||this.$route.query.go==="0" ) {
                // 非官方支付宝 二维码为ur
                this.qrCodeUrl = "https://jijuxjs.com/mpay/pay?orderid="+this.orderid+ "&go=1"
              }
              this.doPay(res.data);
            }

            // console.log("this.qrCodeUrl",this.qrCodeUrl);
          }
        }
        this.channelsText=this.Channel(this.channel,'text')
        this.channelsImg=this.Channel(this.channel,'img')
      });
    },

    doPay (data) {
      // console.log("this.$route.query.go",this.$route.query.go);
      if ( this.$route.query.go === "1" ) {
        pay({
          ap : data.providerDirectory, pid : data.providerId, orderid : data.orderid, openid : this.openid,
        }).then(res => {
          if ( res.code !== 200 ) {
            return this.$message.error("下单失败！");
          }
          if ( res.data.infoType === "html" ) {
            const div     = document.createElement("div");
            div.innerHTML = res.data.infoData;
            document.body.appendChild(div);
            document.forms[0].submit();
          }
          else if ( res.data.infoType === "url" ) {
            // console.log("res.data.payUrl",res.data.payUrl);
            // this.qrCodeUrl = res.data.payUrl;
            // console.log(this.qrCodeUrl);
            window.location.href = res.data.payUrl;
          }
        });
      }
    },
		// 获取微信code
		getWechatCode () {
			window.location.href = `https://open.weixingzh.qq.com/connect/oauth2/authorize?appid=wx076c77fcd9783440&redirect_uri=${ encodeURIComponent(window.location.href) }&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
		},
	},
};
</script>
<style>
.el-dialog__header{
  background-color: #0066FF !important;
}
.el-dialog__body{
  padding:inherit !important;
}
.el-dialog__title{
  color: #fff !important;
}
.el-dialog__headerbtn .el-dialog__close{
  color: #fff !important;
}
</style>
<style lang="less" scoped>
@import '../../../assets/style/default2023/font.css';
@import '../../../assets/style/default2023/css.css';

.pay-box{
  display: flex;
  justify-content: start;
  .pay-box-item{
    cursor: pointer;
    display: flex;
    justify-content:center;
    padding: 8px 24px;
    border:1px solid #F0F0F0;
    border-radius: 5px;
    margin-right: 10px;
    img{
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .active{
    color: #0066FF;
    border-color: #0066FF;
    position: relative;
  }
  .active::after{
    content: "";
    position: absolute;
    background:url("~@/assets/img/default1/select.png");
    background-size: cover;
    width: 23px;
    height: 19px;
    right: 0;
    bottom: 0;
  }

}
.pay-ewm-box{
  background:url("~@/assets/img/default1/paybg.png") no-repeat;
  background-size: 100% 30%;
  .pay-ewm-box-header{
    text-align: center;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
  }
  .ewm-box{
    text-align: center;
    margin-top: 40px;
    .pay-qr-code-box{
      text-align: center;
      .pay-qr-code{
        background: #DBEAFF;
        padding: 12px;
        border-radius: 5px;
        box-shadow:0 0 17px #DBEAFF ;
      }
    }

  }
  .tips-box{
    display: flex;
    padding: 20px;
    justify-content: center;
    .tips-box-left{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: 30px;
      position: relative;
      img{
        width: 38px;
        height: 43px;
      }
    }
    .tips-box-left::after{
      content: "";
      position: absolute;
      background: #979797;
      width: 1px;
      height: 43px;
      right: 0;
      top: 1px;
      opacity: 0.3;
    }
    .tips-box-right{
      padding-left: 25px;
      p{
        font-size: 12px;
      }
    }
  }
}
.option-box{
  display: flex;
  justify-content: space-between;
  padding: 5px 12px;
}
.contact{
  display: flex;
  justify-content: space-between;
}
.notice-btn-box{
  display: flex;
  justify-content: start;
  .notice-btn{
    padding: 8px 26px;
    border:1px solid #F0F0F0;
    border-radius: 5px;
    line-height: normal;
    margin-right: 6px;
    cursor: pointer;
  }
  .active{
    color: #0066FF;
    border-color: #0066FF;
    position: relative;
  }
  .active::after{
    content: "";
    position: absolute;
    background:url("~@/assets/img/default1/select.png");
    background-size: cover;
    width: 23px;
    height: 19px;
    right: 0;
    bottom: 0;
  }
}
.el-form-item--medium.el-form-item{
  margin-bottom: 18px;
}
.form-item-my{
  display: flex;
  justify-content: space-between;
}
.remark-box{
  width: 70%;
  margin: 0 auto;
  background: #fff;
  .remark-box-title{
    padding: 0 60px;
    //border-bottom: 1px #9c9c9c dashed;
    div{
      height: 45px;
      line-height: 45px;
      border-top:2px solid #0066FF;
      color: #0066FF;
      display: inline-block;
    }

  }
  .remark-box-content{
    padding: 0 60px 60px;
  }
}
.main-box{
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .good-box{
    width: 66%;
    background: #fff;
    padding: 0 60px;
    .good-box-title{
      div{
        height: 45px;
        line-height: 45px;
        border-top:2px solid #0066FF;
        color: #0066FF;
        display: inline-block;
      }

    }
  }
  .info-box{
    width: 33%;
    .info-item{
      padding: 0 40px 20px;
      background: #fff;
      .info-box-title{
        div{
          height: 45px;
          line-height: 45px;
          border-top:2px solid #0066FF;
          color: #0066FF;
          display: inline-block;
        }

      }
      .info-box-content{
        background: #fff;
        .info-item{
          margin-bottom: 12px;
          position: relative;
          padding: 16px 18px;
          background: #F6F6F6;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          .qr-box{
            position: absolute;
            width: 190px;
            height:190px;
            background: #fff;
            bottom: 0;
            right: -190px;
            .qr-code1{

            }
          }
          .copy-btn{
            color: #02a9f1;
            position: relative;
            cursor: pointer;
          }
          .copy-btn::after{
            content: "";
            //border: 1px solid #979797;
            height: 13px;
            opacity: 0.31;
            width: 1px;
            background:#979797;
            position: absolute;
            top: 4px;
            left: -18px;
          }
        }
      }
    }

  }
}
.search_box{
  width: 100%;
  padding: .2rem 52px .2rem 0;
  display: flex;
  //padding-right: 52px;
  margin-bottom: 15px;
}
.search_box input{
  flex: 1;
  height: 45px;
  border-radius: 5px 0 0 5px;
  border-color:#722ed1;
  text-indent: 10px;
}
.search_box .search_btn{
  flex: 0.3;
  height:45px;
  line-height: 45px;
  background: #722ed1;
  border-radius: 0 5px 5px 0 ;
  text-align: center;
  color: #fff;
  padding: 2px 0;
}
.sms_active {
	background: #ffa214;
	color: #fff;
}

.email_active {
	background-color: #9460fd;
	color: #fff;
}

.confirm-order-btn {
	margin-left: 36px;
	width: 228px;
	height: 58px;
	background: #722ed1;
	border-radius: 10px;
	color: #fff;
}

.goods-descript /deep/ img {
	max-width: 60%;
}

.qr-code {
	margin-top: 5%;
	margin-left: 43%;
	width: 55%;
}

</style>



// WEBPACK FOOTER //
// src/components/index/default2023/index.vue